import { render, staticRenderFns } from "./TermsAndAgreements.vue?vue&type=template&id=6362007a&scoped=true"
import script from "./TermsAndAgreements.vue?vue&type=script&lang=js"
export * from "./TermsAndAgreements.vue?vue&type=script&lang=js"
import style0 from "./TermsAndAgreements.vue?vue&type=style&index=0&id=6362007a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362007a",
  null
  
)

export default component.exports